export default __webpack_public_path__ + "assets/images/h-city-icon-c1e9da87.svg";